import React from 'react';
import Styled from 'styled-components';

const Loader = Styled.div`
display: flex;
width: 80px;
height: 10px;
background-color: #f5f5f8;
border-radius: 2px;
`;

export const CalculationLoader = () => {
	return <Loader />;
};
